import { CONT_LENS, IContainerInformation, TCG_IN_MMM } from "@tedivo/tedivo-bay-grid-pure";
import { TContainerNameFn, TContainersSymbolsConfig } from "@tedivo/tedivo-bay-grid-core";
import { feetToMillimeters, roundDec } from "@tedivo/tedivo-pure-helpers";

export function generateTopContSymbols(
  prefixSymbol: string,
): TContainersSymbolsConfig<IContainerInformation> {

  const nameFn: TContainerNameFn<IContainerInformation> =
    (prefixSymbol, contInfo) => `${prefixSymbol}_${contInfo.size}`;

  const config: TContainersSymbolsConfig<IContainerInformation> = {
    prefixSymbol,
    nameFn,
    conts: [],
    pathFn: (lengthInMM: number, heightInMM: number) =>
      `M${-lengthInMM * 0.5},${-heightInMM * 0.5} h${lengthInMM} v${heightInMM} h-${lengthInMM} z`
  };

  config.conts = CONT_LENS.map((len) => {
    return {
      name: nameFn(prefixSymbol, { size: len } as IContainerInformation, 0),
      lengthInMM: roundDec(feetToMillimeters(len), 0),
      heightInMM: TCG_IN_MMM,
      fillColor: "#ffffff",
      strokeColor: "#d4d4d8",
      fillOpacity: 0.5,
      strokeOpacity: 0.66,
      strokeWidth: 2,
      strokeDashLength: 1.5,
      dashInTheMiddle: len >= 40,
    };
  });

  console.log(config);

  return config;
}
